import React from 'react'

const CopyButton = ({ onClick = () => {}, disabled = false, text = '', copyText = 'Copied', copied = false }) => {
  return (
    <button
      type="button"
      className="mb-1 px-4 text-xs py-1 w-full text-purple-500 border border-purple-500 hover:text-white hover:bg-purple-500 outline-none focus:outline-none font-semibold rounded-lg"
      onClick={onClick}
      disabled={disabled}
    >
      {copied ? copyText : text}
    </button>
  )
}

export default CopyButton
